import VersionApi from '@apis/version/VersionApi';
import { createQueryKeys } from '@lukemorales/query-key-factory';
import { GetVersionParams } from '@models/version';

const versionQueries = createQueryKeys('version', {
    check: (params: GetVersionParams) => ({
        queryKey: ['version'],
        queryFn: () => VersionApi.getVersion(params),
    }),
});

export default versionQueries;
